import { ModelEntityType } from '@upright/common/model/input/types';
import { SdgTarget } from '@upright/common/model/output/scores/sdg-alignment/types';
import { getTextStyle } from '@upright/ui/common/generic/content/texts/bou-text/text-style';
import { friendlyModelEntityType } from '@upright/ui/untidy/texts';
import { sortBy } from 'lodash';
import styled from 'styled-components';
import { WarningAlert } from '../../../../../../generic/components/alerts/warning-alert';
import { getSdgTargetDescription } from '@upright/common/model/output/scores/sdg-alignment/sdg-targets';

interface Props {
  targets: SdgTarget[];
  entityType: ModelEntityType.COMPANY | ModelEntityType.GROUP | ModelEntityType.PORTFOLIO;
}

export const SdgModalCaseSingleCause = (props: Props) => {
  const notification = (
    <div>
      This SDG drilldown is hidden to protect sensitive or confidential information. Drilldowns for other SDGs for this{' '}
      {friendlyModelEntityType(props.entityType).toLowerCase()} may still be available.
    </div>
  );
  return (
    <Root>
      <WarningAlert>{notification}</WarningAlert>
      <TargetsWithDescriptions targets={props.targets} />
    </Root>
  );
};

const TargetsWithDescriptions = ({ targets }: { targets: SdgTarget[] }) => {
  if (targets.length === 0) {
    return <></>;
  }
  const targetsWithDescriptions = targets.map(target => {
    return {
      number: target,
      description: getSdgTargetDescription(target),
    };
  });
  const sorted = sortBy(targetsWithDescriptions, ['number']);
  return (
    <>
      <p>Contributing targets include:</p>
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        {sorted.map(target => (
          <li key={target.number}>
            <strong>• {target.number}:</strong> {target.description}
          </li>
        ))}
      </ul>
    </>
  );
};

const Root = styled.div`
  ${getTextStyle({ size: 'xxs' })}
  padding: 1em;
  > div:first-child {
    margin-bottom: 1em;
  }
`;
